import PropTypes from 'prop-types';
import React from 'react';

import Button from 'dpl/common/design_system/Button';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEW_FEATURE_LOCATIONS
} from 'dpl/constants/analytics';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';
import { sendRudderstackEvent } from 'dpl/util/analytics';
import { isLessThanBreakpoint } from 'dpl/util/grid';

const IS_LT_MD = isLessThanBreakpoint('md');

export default function FiltersButton({ resultsType, onClick }) {
  function handleFilterButtonClick(e) {
    onClick();

    sendRudderstackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      button_cta: e.target.textContent,
      view:
        resultsType === RESULTS_TYPES.PUPPIES
          ? ANALYTICS_VIEWS.PUPPY_SEARCH_RESULTS
          : ANALYTICS_VIEWS.BREEDER_SEARCH_RESULTS,
      view_feature: ANALYTICS_VIEW_FEATURES.SORT_FILTER_BUTTON,
      view_feature_location: ANALYTICS_VIEW_FEATURE_LOCATIONS.SEARCH_HEADER
    });
  }

  return (
    <div className="BreederSearchResultsFilterPanel">
      <Button
        className={IS_LT_MD ? 'br-100' : 'pv4'}
        variant="outline"
        iconName="fetch-filter"
        iconSize={IS_LT_MD ? '24px' : '20px'}
        size={IS_LT_MD ? 'icon' : 'tiny'}
        onClick={e => handleFilterButtonClick(e)}
      >
        {!IS_LT_MD && <span className="font-16 fw-normal">Filter</span>}
      </Button>
    </div>
  );
}

FiltersButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  resultsType: PropTypes.string.isRequired
};
